<section>
  <h1 *ngFor="let line of text">{{line}}</h1>
</section>
